export class tutorials {

    activate() {
        this.showVideo = false;
        
        var delayInMilliseconds = 500; //2 second

        setTimeout(function() {
            $('.dashboard').css('background', '#fff');
        }, delayInMilliseconds);
    }
    showVideoClicked(url) {
        this.showVideo = true;
        this.videoPlayer.src = url;
        this.videoPlayer.load();
        this.videoPlayer.play();
    }

    showVideoClosed() {
        this.showVideo = false;
        if (this.videoPlayer) {
            this.videoPlayer.pause();
        }
    }
}